export class ZoneIdRequest{
    zoneId:number;
    rackId:number;
    plantId?:number;
    saleOrderId?:number;
    constructor(zoneId:number,rackId:number,plantId?:number,saleOrderId?:number){
        this.zoneId = zoneId;
        this.rackId = rackId;
        this.plantId = plantId;
        this.saleOrderId = saleOrderId;
    }
}